/** Check if a given object is a function */
export function isFunction(func: any) {
  return func && {}.toString.call(func) === '[object Function]';
}
